module.exports = __webpack_public_path__ + "img/作业.897ab7f9.png";